import React, { useState } from 'react';
import t from '~t';
import Items from '~co/collections/items';
import { Modal, ModalHeader as Header, ModalContent as Content, Layout, Search } from '~ui';

export default function CollectionsPicker({ onClose, ...etc }) {
  const [options, setOptions] = useState({
    hideIds: [0],
    search: '',
  });

  const onSearchChange = (e) =>
    setOptions({ ...options, search: e.target.value });

  return (
    <Modal onClose={onClose} stretch>
      <Header title={t.s('selectCollection')} data-no-shadow />

      <Layout>
        <Search
          autoFocus
          value={options.search}
          placeholder={t.s('findOrCreateCollection') + '…'}
          onChange={onSearchChange}
        />
      </Layout>

      <Content className='overflow-clip'>
        <Items pauseId='picker' {...etc} options={options} />
      </Content>
    </Modal>
  );
}
